export default __webpack_public_path__ + "static/media/3233 spice rack B side.9d7da9dc.png";